import {Injectable} from "@angular/core";
import {Http} from "@angular/http";
import {Observable} from "rxjs/Observable";
import {OnfidoProfile} from "../entity";

@Injectable()
export class OnfidoService {

    constructor(private _http: Http) {
    }

    getResult(profileId: number): Observable<OnfidoProfile> {
        return this._http.get(`/api/backoffice/verification/onfido/${profileId}`)
            .map(response => response.json());
    }

    createApplicant(profileId: number): Observable<any> {
        return this._http.post(`/api/backoffice/verification/onfido`, {clientProfileId: profileId});
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/onfido.service.ts